<!--Mobile Nav-->
<fgb-page-header [pageTitle]="'earn.page.title'" [showBalance]="false"></fgb-page-header>

<div class="container">
  <fgbcl-earn-points [svgColor]="'primary'"></fgbcl-earn-points>
</div>
